import { useSelector } from 'react-redux'
import { getCharityOptions, getCharityOptionsEnabled, getRoundUpForCharityFeatureEnabled } from '../../selectors/menus'
import { getNextDollar } from '../../utils/charityConfig'
import { isEmpty } from '../../VNUtil/VNUtils'
import { useCallback } from 'react'

export const useCharity = () => {
  const roundUpEnabled = useSelector(getRoundUpForCharityFeatureEnabled)
  const charityOptionsEnabled = useSelector(getCharityOptionsEnabled)
  const charityOptions = useSelector(getCharityOptions)

  const getRoundUpForCharityFeature = useCallback(
    (total) => {
      const isNextDollarZero = roundUpEnabled && getNextDollar(total) === 0

      if (!roundUpEnabled) {
        return false
      }

      if (isNextDollarZero && !charityOptionsEnabled) {
        return false
      }

      if (isNextDollarZero && charityOptionsEnabled && isEmpty(charityOptions)) {
        return false
      }

      return (charityOptionsEnabled || roundUpEnabled) ?? false
    },
    [charityOptions, charityOptionsEnabled, roundUpEnabled],
  )

  return {
    getRoundUpForCharityFeature,
  }
}
